import { render } from "./market_share.vue?vue&type=template&id=648099df&scoped=true"
import script from "./market_share.vue?vue&type=script&lang=js"
export * from "./market_share.vue?vue&type=script&lang=js"

import "./market_share.vue?vue&type=style&index=0&id=648099df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648099df"]])

export default __exports__